import { render } from "./GrammarPage.vue?vue&type=template&id=19319b39&scoped=true"
import script from "./GrammarPage.vue?vue&type=script&lang=js"
export * from "./GrammarPage.vue?vue&type=script&lang=js"

import "./GrammarPage.vue?vue&type=style&index=0&id=19319b39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19319b39"]])

export default __exports__